import {useState} from 'react';

export default function PDFViewer({src, alt = 'PDF Document'}) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [viewMode, setViewMode] = useState('embed'); // 'embed' or 'iframe'
  const [loadError, setLoadError] = useState(false);

  if (!src) {
    return (
      <div className="border border-border rounded-lg p-8 text-center">
        <p className="text-muted-foreground">No PDF available</p>
      </div>
    );
  }

  // PDF URL with parameters for better viewing experience
  // textLayer=0 disables text extraction to prevent the "extracting text" modal
  const pdfUrl = `${src}#toolbar=1&navpanes=0&scrollbar=1&page=1&view=FitW&zoom=page-width&textLayer=0`;

  return (
    <>
      <div className="space-y-4">
        {/* PDF Viewer */}
        <div className="border border-border rounded-lg overflow-hidden bg-gray-50">
          {loadError ? (
            <div className="p-8 text-center">
              <div className="text-4xl mb-2">⚠️</div>
              <p className="text-muted-foreground mb-4">Failed to load PDF</p>
              <div className="space-x-2">
                <button
                  onClick={() => setLoadError(false)}
                  className="px-3 py-1 text-sm border border-input rounded-md hover:bg-accent">
                  Retry
                </button>
                <a
                  href={src}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-1 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
                  Download PDF
                </a>
              </div>
            </div>
          ) : viewMode === 'embed' ? (
            <embed
              src={pdfUrl}
              type="application/pdf"
              width="100%"
              height="600px"
              className="w-full"
              style={{minHeight: '600px'}}
              onError={() => setLoadError(true)}
            />
          ) : (
            <iframe
              src={pdfUrl}
              width="100%"
              height="600px"
              className="w-full border-0"
              title={alt}
              style={{minHeight: '600px'}}
              onError={() => setLoadError(true)}
            />
          )}
        </div>

        {/* PDF Controls */}
        {/*<div className="flex items-right justify-end p-2">

          <div className="flex space-x-2">
            <button
              onClick={() =>
                setViewMode(viewMode === 'embed' ? 'iframe' : 'embed')
              }
              className="px-3 py-1 text-sm border border-input rounded-md hover:bg-accent">
              {viewMode === 'embed' ? 'Switch to Frame' : 'Switch to Embed'}
            </button>
            <button
              onClick={() => setIsFullscreen(true)}
              className="px-3 py-1 text-sm border border-input rounded-md hover:bg-accent">
              Fullscreen
            </button>
          </div>
          Open in New Tab
                  <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="px-3 py-1 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
          >
            Open in New Tab
          </a>

        </div>*/}
      </div>

      {/* Fullscreen Modal */}
      {isFullscreen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col z-50">
          {/* Fullscreen Header */}
          <div className="flex items-center justify-between p-4 bg-white border-b">
            <h3 className="text-lg font-semibold text-foreground">{alt}</h3>
            <div className="flex space-x-2">
              <a
                href={src}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
                Open in New Tab
              </a>
              <button
                onClick={() => setIsFullscreen(false)}
                className="px-3 py-1 text-sm border border-input rounded-md hover:bg-accent">
                Close
              </button>
            </div>
          </div>

          {/* Fullscreen PDF */}
          <div className="flex-1 bg-white">
            <iframe
              src={pdfUrl}
              width="100%"
              height="100%"
              className="w-full h-full border-0"
              title={alt}
            />
          </div>
        </div>
      )}
    </>
  );
}
